module.exports = new __parcel__URL__("vuln-tab-skeleton.tpl.1a18ea24.svg").toString();